import React, { Component } from "react";

import CategoriesAddForm from "./categoriesAddFront";
import CategoriesAddFunc from "./categoriesAddFunc";

import { withRouter } from "react-router-dom";
import * as ROUTES from "../../../../constants/routes";

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const INITIAL_STATE = {
  funds: [],
  categoryCode: "",
  categoryTitle: "",
  choosenFunds: [],
  categoryDescription: "",
  categoryOrder: "",
  categoryIcon: [],
  categoryCodeError: "",
  categoryTitleError: "",
  choosenFundsError: "",
  categoryDescriptionError: "",
  categoryIconError: "",
  fileName: "",
  iconPreview: "",
  isLoading: false,
  toggleAlert: false,
  messageType: "warning",
  messageAlert: "",
  toggleActionAlert: false,
};

class CategoriesAddFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
    this.categoriesAddFunction = new CategoriesAddFunc();
    this.db = firebase.firestore();
  }

  handleInputChange = async (event) => {
    if (event.target.name === "categoryIcon") {
      const file = event.target.files;

      if (file.length > 0) {
        var dimension = await this.getImageDimension(file);

        if (dimension.width > 1000 || dimension.height > 1000) {
          this.setState({
            categoryIcon: [],
            fileName: "",
            iconPreview: "",
            categoryIconError: "File exceeds the maximum size (1000x1000px)",
          });
          event.target.value = null;
        } else if (dimension.width < 50 && dimension.height < 50) {
          this.setState({
            categoryIcon: [],
            fileName: "",
            iconPreview: "",
            categoryIconError: "File does not meet the minimum size (50x50px)",
          });
          event.target.value = null;
        } else {
          const previewUrl = URL.createObjectURL(file[0]);
          this.setState({
            categoryIcon: file,
            fileName: file[0].name,
            iconPreview: previewUrl,
            categoryIconError: "",
          });
        }
      } else {
        this.setState({
          categoryIcon: [],
          fileName: "",
          iconPreview: "",
          categoryIconError: "",
        });
      }
    } else {
      const name = event.target.name;
      this.setState({ [event.target.name]: event.target.value }, () => {
        this.validator(name);
      });
    }
  };

  getImageDimension(file) {
    const dimension = [];
    var _URL = window.URL || window.webkitURL;
    var img;

    var promise = new Promise((resolve, reject) => {
      img = new Image();
      img.onload = function () {
        dimension.push({ width: this.width, height: this.height });
        resolve(dimension[0]);
      };
      img.onerror = function (err) {
        reject(err.message);
      };
      img.src = _URL.createObjectURL(file[0]);
    });

    return promise;
  }

  validator = (name) => {
    const { categoryCode, categoryTitle } = this.state;

    switch (name) {
      case "categoryCode":
        if (categoryCode.trim() === "") {
          this.setState({ categoryCodeError: "Please input category code." });
        } else {
          this.setState({ categoryCodeError: "" });
        }
        break;
      case "categoryTitle":
        if (categoryTitle.trim() === "") {
          this.setState({ categoryTitleError: "Please input category title." });
        } else {
          this.setState({ categoryTitleError: "" });
        }
        break;
      default:
        break;
    }
  };

  onSubmit = (event) => {
    event.preventDefault();

    this.setState({ isLoading: true });

    const {
      categoryCode,
      categoryTitle,
      categoryDescription,
      categoryOrder,
      categoryIcon,
      categoryCodeError,
      categoryTitleError,
      categoryIconError,
    } = this.state;

    const isValid = categoryCodeError === "" && categoryTitleError === "" && categoryIconError === "";

    if (isValid) {
      this.categoriesAddFunction
        .doCategoryAdd(categoryTitle, categoryDescription, categoryCode, categoryOrder, categoryIcon)
        .then(() => {
          this.setState({
            isLoading: false,
            toggleActionAlert: true,
            messageType: "success",
            messageAlert: "Category added successfully.",
          });

          setTimeout(() => {
            this.props.history.push(ROUTES.CATEGORIES_LIST);
          }, 1000);
        })
        .catch((error) => {
          this.setState({
            isLoading: false,
            toggleActionAlert: true,
            messageType: "error",
            messageAlert: error.message,
          });
        });
    } else {
      this.setState({
        isLoading: false,
      });
    }
  };

  onhandleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ toggleActionAlert: false });
  };

  render() {
    return (
      <CategoriesAddForm
        state={this.state}
        onChange={() => this.handleInputChange.bind(this)}
        onSubmit={() => this.onSubmit.bind(this)}
        onhandleClose={() => this.onhandleClose.bind(this)}
      />
    );
  }
}

export default withRouter(CategoriesAddFormBase);
